import { ViewModel,View, ObservableArray } from "binder"
import  { ProductImagesView } from "./productImages-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { ProductImageManipulationView } from "./productImageManipulation/productImageManipulation-view";
import { ProductImageManipulationViewModel } from "./productImageManipulation/productImageManipulation-viewModel";

export class ProductImagesViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تصاویر کالاها'
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.items = ObservableArray.create<singleItem>();
    }
    GetDefaultView(): View <ViewModel> {
        return new ProductImagesView();
    }
    public getTypeId(): string {
        return "VM-9AB5F310-13C4-4650-8883-710D6952F9FA"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<singleItem>) { this._items = v; } public get items(): ObservableArray<singleItem> { return this._items;} private _items: ObservableArray<singleItem>;
    
    refresh(){
        this.loader.refresh();
    }
    
    async refreshPaged(filteringInformation: any) :Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ProductImagesServices/GetAllProductsWithImageInfo',{
                FilteringInformation : filteringInformation
            });
            this.items.update(...result.PagedResult.map((x,i)=>{
                let r = new singleItem(this);
                r.index = i+1;
                r.productId = x.ProductId;
                r.measuredProductId = x.MeasuredProductId;
                r.name = x.Name;
                r.code = x.Code;
                r.productCarModel = x.ProductCarModel;
                r.isWrecked = x.IsWrecked;
                r.locations = x.Location;
                r.balance = x.Balance;
                r.accessibleBalance = x.AccessibleBalance;
                r.hasPicture = x.HasPicture;
                r.files.update(...x.Files.map(y=>{
                    let f = new singleFile(r);
                    f.name = y.Name;
                    f.path = `/media/${y.Path}`;
                    return f;
                }))
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);

        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
        return null;
    }

}

export class singleItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.files = ObservableArray.create<singleFile>();
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set isWrecked(v: boolean) { this._isWrecked = v; } public get isWrecked(): boolean { return this._isWrecked;} private _isWrecked: boolean;
    public set hasPicture(v: boolean) { this._hasPicture = v; } public get hasPicture(): boolean { return this._hasPicture;} private _hasPicture: boolean;
    public set locations(v: string) { this._locations = v; } public get locations(): string { return this._locations;} private _locations: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance;} private _accessibleBalance: number;
    public set files(v: ObservableArray<singleFile>) { this._files = v; } public get files(): ObservableArray<singleFile> { return this._files;} private _files: ObservableArray<singleFile>;
    
    async edit(){
        let popup = new ProductImageManipulationViewModel(this);
        popup.loadById(this.measuredProductId);
        let result = await this.requestShowingPopup(popup);
        if(result=='yes'){
            this.requestRefreshWindow();
        }
    }
}

export class singleFile extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.isShowing = false;    
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path;} private _path: string;
    public set isShowing(v: boolean) { this._isShowing = v; } public get isShowing(): boolean { return this._isShowing;} private _isShowing: boolean;
    
    public set showingPath(v: string) { this._showingPath = v; } public get showingPath(): string { return this._showingPath;} private _showingPath: string;
    
    show(){
        this.isShowing = true;
        this.showingPath = this.path;
    }
    showInNewTab(){
        window.open(this.path,'_blank');
    }
}